import { proxy} from "valtio";

export const state = proxy({
  assetsPath: "./assets/",
  links:{},
  boxOpen:false,
  modelReady:false,
  firstRender:true,
  replayAnim:false,
  startTimeout:0
});
